/*
 * カラーパレット（2026-09-18 追加）
 *
 * WordPress案件の `_variables.scss` と同じ体系にしてある。
 *   $color-orange-main → theme.palette.orange.main
 *   $color-orange-90   → theme.palette.orange[90]
 * main を基準に、90〜5 が明るい方向、110〜150 が暗い方向。
 *
 * 新しく書くコードはこちらを使う。既存の `colors` は当面そのまま残す
 * （一括置換はせず、触った画面から順に移行する。詳細は docs/design-rule.md）。
 */
export const palette = {
    // 主色。ボタン・アクティブ状態
    orange: {
        main: "#FF6A0C",
        90: "#FF7924",
        80: "#FF883D",
        70: "#FF9755",
        60: "#FFA66D",
        50: "#FFB486",
        40: "#FFC39E",
        30: "#FFD2B6",
        20: "#FFE1CE",
        10: "#FFF0E7",
        5: "#FFF8F3",
        110: "#E65F0B",
        120: "#CC550A",
        130: "#B24A08",
        140: "#994007",
        150: "#803506",
    },
    // 本文の文字色
    black: {
        main: "#464646",
        90: "#585858",
        80: "#6B6B6B",
        70: "#7E7E7E",
        60: "#909090",
        50: "#A2A2A2",
        40: "#B5B5B5",
        30: "#C8C8C8",
        20: "#DADADA",
        10: "#ECECEC",
        5: "#F6F6F6",
        110: "#3F3F3F",
        120: "#383838",
        130: "#313131",
        140: "#2A2A2A",
        150: "#232323",
    },
    // エラー
    red: {
        main: "#FF597B",
        90: "#FF6A88",
        80: "#FF7A95",
        70: "#FF8BA3",
        60: "#FF9BB0",
        50: "#FFACBD",
        40: "#FFBDCA",
        30: "#FFCDD7",
        20: "#FFDEE5",
        10: "#FFEEF2",
        5: "#FFF7F8",
        110: "#E6506F",
        120: "#CC4762",
        130: "#B23E56",
        140: "#99354A",
        150: "#802C3E",
    },
    // 情報
    blue: {
        main: "#608DFF",
        90: "#7098FF",
        80: "#80A4FF",
        70: "#90AFFF",
        60: "#A0BBFF",
        50: "#B0C6FF",
        40: "#BFD1FF",
        30: "#CFDDFF",
        20: "#DFE8FF",
        10: "#EFF4FF",
        5: "#F7F9FF",
        110: "#567FE6",
        120: "#4D71CC",
        130: "#4363B2",
        140: "#3A5599",
        150: "#304680",
    },
    // 成功
    green: {
        main: "#5BCF54",
        90: "#6BD465",
        80: "#7CD976",
        70: "#8CDD87",
        60: "#9DE298",
        50: "#ADE7AA",
        40: "#BDECBB",
        30: "#CEF1CC",
        20: "#DEF5DD",
        10: "#EFFAEE",
        5: "#F7FDF6",
        110: "#52BA4C",
        120: "#49A643",
        130: "#40913B",
        140: "#377C32",
        150: "#2E682A",
    },
    // 注意
    yellow: {
        main: "#F5C865",
        90: "#F6CE74",
        80: "#F7D384",
        70: "#F8D893",
        60: "#F9DEA3",
        50: "#FAE4B2",
        40: "#FBE9C1",
        30: "#FCEED1",
        20: "#FDF4E0",
        10: "#FEFAF0",
        5: "#FEFCF7",
        110: "#DCB45B",
        120: "#C4A051",
        130: "#AC8C47",
        140: "#93783D",
        150: "#7A6432",
    },
    // 無彩色
    white: {
        main: "#FFFFFF",
        bg: "#F2F2F2",      // 画面の背景
        border: "#E4E4E4",  // 境界線
    },
};

export const theme = {
    // 新しいカラーパレット（上で定義）。新規コードはこちらを使う
    palette,
    breakPoints: {
        breakSmall: "321px",
        breakMobile: "375px",
        breakMobilePhone: "414px",
        breakMobileMedium: "575px",
        breakTablet: "767px",
        breakOnlyMobile: "768px",
        breakIpad8:"900px",
        breakMedium: "980px",
        breakIpadPro: "1024px",
        breakLarge: "1200px",
        breakBig: "1367px",
        breakSuperBig: "1824px",
    },
    widths: {
        wide_650: "650px",
        wide_700: "700px",
        wide_900: "900px",
        wide_1110: "1110px",
    },
    colors: {
      white00:"#FFFFFF",
      black01:"#464646",
      white02:"#F2F2F2",
      gray03:"#AEAEAF",
      navyblue04:"#35387B",
      red05:"#FF5959",
      blue06:"#608dff",
      green07:"#5BCF54",
      yellow08:"#F5C865",
      lightgray09:"#E4E4E4",
      orange:"#ff6a0c",
      crimson:"#b62524",

      primary: "#43CDEC",
      secondary: "#FF9D43",
      error: "#FF4343",
      darkBlack: "#292D32",
      black: "#292D32",
      gray: "#F4F4F4",
      gray1: "#656565",
      gray2: "#8E8E8E",
      gray3: "#D5D5D5",
      gray4: "#DEDEDE",
      gray5: "#F0F0F0",
      gray6: "#F4F4F4",
      white: "#FFFFFF",
      borderCheckBox: "#D4D4D4",
      borderButtonIcon: "#F0F0F0",
    },
    borderRadius: {
        base: "8px",
        inputBase: "16px",
    },
    fontFamily: {
        MochiyPopOne_Regular: "'Mochiy Pop One'",
        NotoSansJP_400: "'Noto Sans JP'",
        NotoSansJP_500: "'Noto Sans JP'",
        NotoSansJP_700: "'Noto Sans JP'",
    },
};
